import { useNavigate } from 'react-router-dom';
import FormSpinner from '../../formComponents/FormSpinner';
import NoRecords from '../../formComponents/NoRecords';

export default function ActionDetailsInterventionTable({
  loading,
  data,
  prevURL,
}) {
  const navigate = useNavigate();

  const navigateToForm = (item) => {
    navigate('/mtss/action-details', {
      state: { item: item, from: prevURL },
    });
  };

  return (
    <div className='-mx-4 overflow-hidden shadow-lg ring-1 ring-gray-100 sm:-mx-6 md:mx-0 md:rounded-lg'>
      <h2 className='bg-brandPrimary pl-4 pt-5 text-2xl font-bold text-white sm:pl-6'>
        Other Actions
      </h2>
      <table className='min-w-full divide-y divide-gray-100'>
        <thead className='bg-brandPrimary'>
          <tr>
            <th
              scope='col'
              className='py-3.5 pl-4 pr-3 text-left text-lg font-bold text-white sm:pl-6'
            >
              Intervention
            </th>
            <th
              scope='col'
              className='hidden px-3 py-3.5 text-left text-lg font-bold text-white lg:table-cell'
            >
              SST Member
            </th>
            <th
              scope='col'
              className='hidden px-3 py-3.5 text-left text-lg font-bold text-white lg:table-cell'
            >
              Start Date
            </th>
            <th
              scope='col'
              className='hidden px-3 py-3.5 text-left text-lg font-bold text-white lg:table-cell'
            >
              Next Check-in
            </th>
            <th
              scope='col'
              className='hidden px-3 py-3.5 text-left text-lg font-bold text-white lg:table-cell'
            >
              Concern
            </th>
            <th
              scope='col'
              className='px-3 py-3.5 pr-4 text-left text-lg font-bold text-white sm:pr-6'
            >
              Outcome
            </th>
          </tr>
        </thead>
        <tbody className='divide-y divide-gray-100 bg-white'>
          {data?.map((item) => (
            <tr key={item?.id}>
              <td className='w-full max-w-0 py-4 pl-4 pr-3 text-sm font-normal text-brandText sm:w-auto sm:max-w-none sm:pl-6'>
                <button
                  className='rounded-md font-medium text-brandPrimary duration-300 ease-in-out hover:scale-110 hover:text-brandPrimaryLight focus:border-brandPrimary focus:outline-none focus:ring-2 focus:ring-brandPrimary'
                  onClick={() => {
                    navigateToForm(item);
                  }}
                >
                  <span className='font-bold text-brandText lg:hidden'>
                    Intervention:{' '}
                  </span>
                  {item?.treatment?.treatment_name}
                </button>
                <dl className='font-normal lg:hidden'>
                  <dt className='sr-only'>SST Member</dt>
                  <dd className='mt-1 truncate'>
                    <span className='font-bold'>SST Member: </span>
                    {item?.supervisor?.name}
                  </dd>
                  <dt className='sr-only lg:hidden'>Start Date</dt>
                  <dd className='mt-1 truncate text-brandText lg:hidden'>
                    <span className='font-bold text-brandText'>
                      Start Date:{' '}
                    </span>
                    {item?.start_date}
                  </dd>
                  <dt className='sr-only'>Next Check-in</dt>
                  <dd className='mt-1 truncate'>
                    <span className='font-bold'>Next Check-in: </span>
                    {item?.intervention_next_check}
                  </dd>
                  <dt className='sr-only'>Concern</dt>
                  <dd className='mt-1 truncate'>
                    <span className='font-bold'>Concern: </span>
                    {item?.concern?.concern_name}
                  </dd>
                </dl>
              </td>

              <td className='hidden px-3 py-4 text-sm font-normal text-brandText lg:table-cell'>
                {item?.supervisor?.name}
              </td>
              <td className='hidden px-3 py-4 text-sm font-normal text-brandText lg:table-cell'>
                {item?.start_date_mdy}
              </td>
              <td className='hidden px-3 py-4 text-sm font-normal text-brandText lg:table-cell'>
                {item?.intervention_next_check}
              </td>
              <td className='hidden px-3 py-4 text-sm font-normal text-brandText lg:table-cell'>
                {item?.concern?.concern_name}
              </td>
              <td className='px-3 py-4 text-sm font-normal text-brandText'>
                <dd>{item?.outcome?.outcome_name}</dd>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <FormSpinner loading={loading} />
      <NoRecords loading={loading} data={data} />
    </div>
  );
}
